<template>
  <div class="coproducer-product-card rounded-16 p-6 bg-5">
    <div class="image-container mb-4">
      <img :src="image" alt="produto" v-if="image" />
    </div>

    <div class="d-flex justify-content-between align-items-start mb-2">
      <div>
        <div class="text-semibold fs-14">{{ product.name }}</div>
        <div class="text-dark-40 fs-12">
          {{ formatProductType(product.type_product) }}
        </div>
      </div>
      <div :class="formatStatusClass(status)">
        {{ formatStatus(status) }}
      </div>
    </div>

    <div class="text-dark-80 fs-12 mb-4">
      Criado em {{ formatDate(created_at) }}
    </div>

    <div class="d-flex justify-content-between">
      <snow-button
        size="sm"
        icon="ph ph-link"
        variant="outline"
        text="Links de divulgação"
        @click="openLinks"
      />

      <bp-dropdown
        class="dropdown"
        :actions="actions"
        :disabled="status === 'cancelled'"
        :variant="isGallery ? 'filled-2' : 'glyph'"
        @cancel="cancelContract"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isGallery: Boolean,
    product: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: Number,
      default: null
    },
    status: {
      type: String,
      default: ""
    },
    created_at: {
      type: String,
      default: ""
    }
  },
  computed: {
    image() {
      return this.product?.picture || null;
    },
    actions() {
      const actions = [
        {
          text: "Cancelar contrato",
          class: "text-negative-600",
          icon: "icon-x",
          dialog: {
            text: "Tem certeza que deseja cancelar o contrato?",
            variant: "negative",
            icon: "fa fa-hexagon-exclamation",
            buttonText: "Cancelar",
            secondaryButtonText: "Confirmar"
          },
          event: "cancel"
        }
      ];

      return actions;
    }
  },
  methods: {
    formatStatus(status) {
      return {
        active: "Ativo",
        cancelled: "Cancelado",
        rejected: "Rejeitado",
        waiting_validation: "Aguardando validação",
        pendent: "Pendente"
      }[status];
    },
    formatStatusClass(status) {
      return {
        active: "active-badge",
        cancelled: "inactive-badge",
        rejected: "inactive-badge",
        waiting_validation: "draft-badge",
        pendent: "draft-badge"
      }[status];
    },
    formatDate(value) {
      return new Date(value).toLocaleDateString("pt-BR");
    },
    formatProductType(type_product) {
      return {
        online_course: "Curso Online",
        signature: "Assinatura",
        onsite_event: "Evento presencial"
      }[type_product];
    },

    openLinks() {
      this.$router.push({
        name: "coproducer-product-links",
        params: { id: this.product.id }
      });
    },
    cancelContract() {
      this.loading = true;
      this.$store
        .dispatch("user/updateMyCoproducer", {
          id: this.id,
          status: "cancelled"
        })
        .then(() => {
          this.$emit("refresh");
          this.$message.success("Contrato cancelado com sucesso");
        })
        .catch(() => {
          this.$message.error("Erro ao cancelar contrato");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.coproducer-product-card {
  display: block;
  position: relative;
  color: var(--dark);
  text-decoration: none;
  height: 100%;
  transition: 0.2s all;
  border: 1px solid var(--dark-10);
  padding: 24px;

  .image-container {
    width: 100%;
    aspect-ratio: 1.28;
    background-color: var(--dark-4);
    border-radius: 12px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
